import React from "react";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

const FluidIntakeList = ({ items = [] }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No Fluid intake has been added yet</strong>
            </div>
        );
    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th className="text-center">SN</th>
                    <th>Fluid Offered</th>
                    <th>Amount Taken</th>
                    <th>Staff</th>
                    <th>Date & Time</th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <tr key={index}>
                        <td className="text-center">
                            <strong>{index + 1}</strong>
                        </td>
                        <td className="view-message">
                            <span>{item.offered}</span>
                            <br />
                            <small className="text-muted">
                                <TimeAgo date={item.created_at}></TimeAgo>
                            </small>
                        </td>
                        <td className="view-message">{item.amountTaken}</td>
                        <td>
                            <StaffProfileCard item={item.author} />
                        </td>
                        <td className="view-message">{cleanDate(item.datetime)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default FluidIntakeList;
